export const getTypeOfOption = (SK: string) => {
    const skSplit = SK.split('#')[0];
    const type = skSplit.charAt(0).toUpperCase() + skSplit.slice(1).toLowerCase();
    return type;
};
